import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        is_loading: true,
        is_disabled: false,
        show_navi: false,
        back_url: "/",
        footer: false,
        cookies: false,
        social: false,
        global: false,
        disabled_scroll: false,
        collection: false,
        highlights: false,
        is_show_mobile_navi: false,
        open_accordion_id: -1,
        accordion_open: false,
        accordion_counter: -1,
    }
    // mutations: {
    // },
    // actions: {
    // },
    // modules: {
    // }
});
